<template>
	<el-tabs 
		v-model="currentTab" 
		:type="type"
		:class="[{'hiddenTabs': !showTabs}]">
		
		<el-tab-pane 
			v-for="(tab, i) in tabs"
			:key="i"
			:name="`t-${i}`"
			:label="tab.label">

			<slot :name="`tab-${i}`"></slot>

		</el-tab-pane>
	</el-tabs>
</template>

<script>
	export default {
		name: 'TabPanel',
		props: {
			tabs: Array,
			type: String,
			showTabs: {
				type: Boolean,
				default: true
			}
		},
		data () {
			return {
				currentTab: 't-0'
			}
		},
		watch: {
			tabs () {
				this.currentTab = 't-0'
			}
		},
		created () {
			this.currentTab = 't-0'
		}
	}
</script>

<style lang="scss">
.el-tabs.hiddenTabs > .el-tabs__header {
    display: none!important;
}
</style>
